// extracted by mini-css-extract-plugin
export default {"component":"StartQuiz_component__MCRUH","button":"StartQuiz_button__kfu0B"};